<script lang="ts" setup>
import { getBreadCrumb, usePagination } from '#imports'
import { useFetchBlockList } from '~/api/service/block/list/index.service'
import BlocksPageTable from '~/components/@pages/blocks/BlocksPageTable.vue'
import DetailsBox from '~/components/box/DetailsBox.vue'
import PageTitleHeader from '~/components/header/PageTitleHeader.vue'
import BcPagination from '~/ui/Pagination/BcPagination.vue'

const { pagination, rowPerPageList } = usePagination({
  page: 1,
  rowPerPage: 25
})

const { data, isLoading } = useFetchBlockList(pagination)

useSeoMeta(getMeta('Blocks', 'View the latest blocks'))

useHead(getBreadCrumb())
</script>

<template>
  <PageTitleHeader title="Blocks" />
  <DetailsBox class="my-4">
    Showing all <span class="font-bold text-primary">{{ data?.totalCount }}</span> results
    <template #pagination>
      <BcPagination
        v-if="data?.VCNT"
        v-model="pagination"
        :row-per-page-list="rowPerPageList"
        :total-count="data.VCNT"
        hide-rows-per-page
      />
    </template>
  </DetailsBox>
  <Card>
    <BlocksPageTable
      :rows="data?.blockList || []"
      :is-loading="isLoading"
      :row-cnt="pagination.rowPerPage"
    />
    <BcPagination
      v-if="data?.VCNT"
      v-model="pagination"
      :row-per-page-list="rowPerPageList"
      :total-count="data.VCNT"
    />
  </Card>
</template>

<style scoped>

</style>